/**
 * Index Controller
 */
/*
  globals moment
*/
(function(angular) {
    'use strict';

    var app = angular.module('asSecureCommerce');

    app.controller('SucuriLogIndexController', [
        '$scope',
        '$window',
        '$timeout',
        'seApi',
        function($scope, $window, $timeout, seApi) {
            $scope.data = log.data;
            $scope.modalTitle = 'Api call info: ';
            $scope.modalTitleEditedBy = ' performed by ';
            $scope.showStatus = true;
        },
    ]);
})(window.angular);
